import { NameTagPrinter } from "@/components/badges/NameTagPrinter";

export default function AdminNameTags() {
  return (
    <div className="space-y-5" data-testid="studio-name-tags">
      <div>
        <h1 className="font-serif text-2xl font-semibold text-foreground sm:text-3xl">Name badges</h1>
        <p className="mt-1 text-muted-foreground">
          Print member name badges for the welcome table — each with a scannable QR. Members choose which
          details appear from their My Card settings.
        </p>
      </div>
      <NameTagPrinter />
    </div>
  );
}
